import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import AccountSettings from './components/AccountSettings';
import NavBar from './components/NavBar';
import MobNavBar from './components/MobileNavBar';

import Selector from './components/Selector';

import BetsSidebar from './components/BetsSidebar';
import LoginModal from './components/Login';
import SignupModal from './components/Register';
import UsernameOnboarding from './components/UsernameOnboarding';
import FreeOddsAnnouncement from './components/FreeOddsAnnouncement';
import Disclaimer from './components/Disclaimer';
import PremiumModal from './components/PremiumModal';
import Leaderboard from './components/Leaderboard';
// import CheckoutPremium from './components/CheckoutPremium';
import AddCoinsModal from './components/AddCoinsModal';
import AdminDashboard from './components/AdminDashboard'
import Unsubscribe from './components/Unsubscribe';
import React, { useEffect, useRef, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';  // Make sure to import Firebase auth
import { Navigate } from 'react-router-dom';
import epl from "./images/epl.png";




function App() {
  const appContentRef = useRef(null);
  const betSlipShellRef = useRef(null);
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);

  const [walletBalance, setWalletBalance]= useState(() => {
    // Load selectedOdds from localStorage or initialize as an empty array if none exists
    const walletBalance = localStorage.getItem('walletBalance');
    return walletBalance ? walletBalance : '0.00';
  });
  const [usernameInfo, setUsernameInfo]= useState(() => {
    // Load selectedOdds from localStorage or initialize as an empty array if none exists
    const username = localStorage.getItem('username');
    return username ? username : '';
  });
  const [selectedOdds, setSelectedOdds] = useState(() => {
    // Load selectedOdds from localStorage or initialize as an empty array if none exists
    const savedOdds = localStorage.getItem('selectedOdds');
    return savedOdds ? JSON.parse(savedOdds) : [];
  });

  const [invalidMatches, setInvalidMatches] = useState([]);

  const [betsOpen, setBetsOpen] = useState(() => {
    // Load betsAmount from localStorage or initialize to 0
    const savedBetsOpen = localStorage.getItem('betsOpen');
    return savedBetsOpen === "true";
  });
  const [betAmounts, setBetAmounts] = useState(() => {
    // Load betsAmount from localStorage or initialize to 0
    const savedAmount = localStorage.getItem('betsAmounts');
    return savedAmount ? JSON.parse(savedAmount) : {};
  });
  const [estimatedPayouts, setEstimatedPayouts] = useState(() => {
    // Load estimatedPayout from localStorage or initialize to 0
    const savedPayout = localStorage.getItem('estimatedPayouts');
    return savedPayout ? JSON.parse(savedPayout) : {};
  });
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [signupModalOpen, setSignupModalOpen] = useState(false);
  const [usernamePrompt, setUsernamePrompt] = useState(null);
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [isPremium, setIsPremium] = useState({
    isPremium: false,
    isPremiumTrial: false,
    trialExpiresAt: null,
  });
  const [coinsToAdd, setCoinsToAdd] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [animationClass, setAnimationClass] = useState('');

  const [percentOdds, setPercentOdds] = useState(() => localStorage.getItem('togglePercent') === 'true');
  const [selectedLeague, setSelectedLeague] = useState(() => {
    try {
      const savedLeague = localStorage.getItem("selectedLeague");
      if (savedLeague) {
        const parsedLeague = JSON.parse(savedLeague);
        // Migrate the previously selected qualification feed to the main
        // Champions League competition.
        if (parsedLeague.key === "soccer_uefa_champs_league_qualification") {
          return {
            ...parsedLeague,
            name: "Champions League",
            key: "soccer_uefa_champs_league",
          };
        }
        return parsedLeague;
      }
    } catch (err) {
      console.error("Error parsing selectedLeague from localStorage:", err);
    }
    return { name: "Premier League", icon: epl, key: "soccer_epl" };
  });

  useEffect(() => {
    let frameId;
    let settleTimer;

    const applyViewportHeight = () => {
      const height =
        window.visualViewport?.height || window.innerHeight;

      document.documentElement.style.setProperty(
        "--app-viewport-height",
        `${Math.round(height)}px`
      );
    };

    const refreshViewportHeight = () => {
      applyViewportHeight();

      cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(applyViewportHeight);

      clearTimeout(settleTimer);
      settleTimer = setTimeout(applyViewportHeight, 500);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshViewportHeight();
      }
    };

    refreshViewportHeight();

    window.addEventListener("resize", refreshViewportHeight);
    window.addEventListener("pageshow", refreshViewportHeight);
    window.visualViewport?.addEventListener(
      "resize",
      refreshViewportHeight
    );
    window.screen.orientation?.addEventListener(
      "change",
      refreshViewportHeight
    );
    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );

    return () => {
      cancelAnimationFrame(frameId);
      clearTimeout(settleTimer);
      window.removeEventListener("resize", refreshViewportHeight);
      window.removeEventListener("pageshow", refreshViewportHeight);
      window.visualViewport?.removeEventListener(
        "resize",
        refreshViewportHeight
      );
      window.screen.orientation?.removeEventListener(
        "change",
        refreshViewportHeight
      );
      document.removeEventListener(
        "visibilitychange",
        handleVisibilityChange
      );
    };
  }, []);

  useEffect(() => {
    // Check if the disclaimer has been shown before
    const isDisclaimerShown = localStorage.getItem('isDisclaimerShown');

    if (isDisclaimerShown !== "true") {
      setDisclaimerOpen(true); // Show modal for first-time visitors
    }
  }, []);
  useEffect(() => {
    const fetchUserData = async (currentUser) => {
      if (!currentUser) return; // Ensure currentUser is available before fetching
  
      try {
        const token = await currentUser.getIdToken(); // Get Firebase Auth Token

        const response = await fetch('/api/user-info', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // Send the token in headers
          },
          body: JSON.stringify({ currentUser }),
        });
  
        const data = await response.json();
        if (getAuth().currentUser?.uid !== currentUser.uid) return;
        if (!response.ok) throw new Error(data.error || 'Unable to load account.');
        if (data.needsUsername) {
          setUsernamePrompt({ user: currentUser, required: true });
          setWalletBalance(0);
          setUsernameInfo('');
          localStorage.setItem('username', '');
          localStorage.setItem('walletBalance', '0');
          setRole(false);
          setIsPremium({ isPremium: false, isPremiumTrial: false, trialExpiresAt: null });
          return;
        }
        setUsernamePrompt(data.showUsernameReminder ? { user: currentUser, required: false } : null);
        // console.log(data)
        setWalletBalance(data.user?.wallet_balance || 0);
        setUsernameInfo(data.user?.username || '')
        localStorage.setItem('username', (data.user?.username || ''));
        // console.log(data.user?.username)
        localStorage.setItem('walletBalance', (data.user?.wallet_balance || 0));
        setRole(data.user?.admin ?? false); // Ensure role is always set
        setIsPremium({
          isPremium: Boolean(data.user?.isPremium),
          isPremiumTrial: Boolean(data.user?.isPremiumTrial),
          trialExpiresAt: data.user?.trialExpiresAt || null,
        });
        // console.log("User Info:", data);
      } catch (error) {
        console.error("Error getting wallet balance:", error);
      }
    };
  
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUsernamePrompt(null);
      // Never expose an unverified email/password account as logged in. The
      // backend independently enforces the same rule for direct API calls.
      if (currentUser && currentUser.email && !currentUser.emailVerified) {
        setUser(null);
        setRole(false);
      } else if (currentUser) {
        setUser(currentUser);
        // console.log(currentUser);
        await fetchUserData(currentUser);
      } else {
        setUser(null);
        setRole(false); // Ensure role is set to false when logged out
      }
      setLoading(false);
    });
  
    return () => unsubscribe();
  }, []);

  // Update localStorage whenever selectedOdds changes
  
  useEffect(() => {
    // console.log(selectedOdds)
    localStorage.setItem('selectedOdds', JSON.stringify(selectedOdds));
  }, [selectedOdds]);

  // Update localStorage whenever betsAmount changes
  useEffect(() => {
    // console.log(betAmounts)
    localStorage.setItem('betsAmounts', JSON.stringify(betAmounts));
  }, [betAmounts]);

  // Update localStorage whenever estimatedPayout changes
  useEffect(() => {
    // console.log(estimatedPayouts)
    localStorage.setItem('estimatedPayouts', JSON.stringify(estimatedPayouts));
  }, [estimatedPayouts]);

  useEffect(() => {
    // console.log(betsOpen)
    localStorage.setItem('betsOpen', betsOpen);
  }, [betsOpen]);

  useEffect(() => {
    const mobileLayout = window.matchMedia('(max-width: 768px)');
    const appContent = appContentRef.current;
    const betSlipShell = betSlipShellRef.current;

    const syncBetSlipAccessibility = () => {
      if (betSlipShell) {
        betSlipShell.inert = !betsOpen;
      }

      if (appContent) {
        appContent.inert = betsOpen && mobileLayout.matches;
      }
    };

    syncBetSlipAccessibility();
    mobileLayout.addEventListener?.('change', syncBetSlipAccessibility);

    return () => {
      mobileLayout.removeEventListener?.('change', syncBetSlipAccessibility);
      if (appContent) appContent.inert = false;
    };
  }, [betsOpen]);

  useEffect(() => {
    // console.log(betsOpen)
    localStorage.setItem('selectedLeague', JSON.stringify(selectedLeague));
  }, [selectedLeague]);

  const handleClearAllBets = () => {
    setSelectedOdds([]); // Clear all selected bets
    setBetAmounts({});   // Reset all bet amounts
    setEstimatedPayouts({}); // Reset all estimated payouts
  };

  const openLoginModal = () => setLoginModalOpen(true);
  const closeLoginModal = () => setLoginModalOpen(false);

  const openSignupModal = () => {
    setSignupModalOpen(true);
  }
  const closeSignupModal = () => setSignupModalOpen(false);

  const closeDisclaimerModal = () => {
    setDisclaimerOpen(false);
    localStorage.setItem('isDisclaimerShown', 'true'); // Set the flag in localStorage
  }
  
  // Function to close the sidebar
  const closeSidebar = () => {
    setBetsOpen(false);
  };
  const [premiumModal, setPremiumModal] = useState(false)

  const openPremiumModal = () => setPremiumModal(true);
  const closePremiumModal = () => setPremiumModal(false);

  const [addCoinsModal, setAddCoinsModal] = useState(false)
  const openAddCoinsModal = () => setAddCoinsModal(true);
  const closeAddCoinsModal = () => setAddCoinsModal(false);

  
  return (
    <div>
      <div className='top-nav bg-black'></div>
      <div className='bot-nav bg-black shadow-box'></div>
      <LoginModal showModal={loginModalOpen && !usernamePrompt} closeModal={closeLoginModal} user = {user} setUser = {setUser} setSignupModalOpen={setSignupModalOpen} />
      <SignupModal showModal={signupModalOpen && !usernamePrompt} closeModal={closeSignupModal} setUser={setUser} setLoginModalOpen={setLoginModalOpen} setDisclaimerOpen={setDisclaimerOpen} setWalletBalance={setWalletBalance} setUsernameInfo={setUsernameInfo}/>
      <Disclaimer showModal={disclaimerOpen && !usernamePrompt} closeModal={closeDisclaimerModal} user = {user} setUser = {setUser}/>
      {usernamePrompt && <UsernameOnboarding key={usernamePrompt.user.uid} {...usernamePrompt}
        onDismiss={() => setUsernamePrompt(null)} onComplete={(data) => {
          if (getAuth().currentUser?.uid !== usernamePrompt.user.uid) return;
          setUsernameInfo(data.username);
          localStorage.setItem('username', data.username);
          if (data.wallet_balance !== undefined) {
            setWalletBalance(data.wallet_balance);
            localStorage.setItem('walletBalance', data.wallet_balance);
          }
          setUsernamePrompt(null);
          setLoginModalOpen(false);
          setSignupModalOpen(false);
        }} />}
      <PremiumModal showModal={premiumModal} closeModal={closePremiumModal} user = {user} isPremium={isPremium} setIsPremium={setIsPremium} openSignupModal={openSignupModal} />
      <AddCoinsModal showModal={addCoinsModal} closeModal={closeAddCoinsModal} setUser={setUser} user = {user} setCoinsToAdd={setCoinsToAdd}/>


      <div className="App d-flex">
        <div ref={appContentRef} className={`app-in m-auto ${betsOpen ? 'home':'homesmall'}`}>
        <NavBar className={`m-auto ${betsOpen ? 'navbar':'navbarsmall'}`} openLoginModal = {openLoginModal} openSignupModal = {openSignupModal} user = {user} setUser = {setUser} selectedOdds={selectedOdds} setBetsOpen={setBetsOpen} betsOpen={betsOpen} handleClearAllBets={handleClearAllBets} walletBalance={walletBalance} loading={loading} setLoading={setLoading} setRole={setRole} setIsPremium={setIsPremium} setUsernameInfo = {setUsernameInfo} />
        
        
        
        
        
        <BrowserRouter>
          <FreeOddsAnnouncement eligible={!loading && !disclaimerOpen && !usernamePrompt
            && !loginModalOpen && !signupModalOpen && !premiumModal && !addCoinsModal && !betsOpen} />
          <Routes>
            <Route path = '/' element={
              <>
                <Selector selectedLeague={selectedLeague} setSelectedLeague={setSelectedLeague} />
                <Home user={user} setUser={setUser} walletBalance={walletBalance} setWalletBalance={setWalletBalance} isPremium={isPremium} setIsPremium={setIsPremium} selectedOdds={selectedOdds} setSelectedOdds={setSelectedOdds} betsOpen={betsOpen} setBetsOpen={setBetsOpen} betAmounts={betAmounts} setBetAmounts={setBetAmounts} estimatedPayouts={estimatedPayouts} setEstimatedPayouts={setEstimatedPayouts} handleClearAllBets={handleClearAllBets} openPremiumModal={openPremiumModal} closePremiumModal={closePremiumModal} showAlert={showAlert} setShowAlert={setShowAlert} alertText={alertText} setAlertText={setAlertText} animationClass={animationClass} setAnimationClass={setAnimationClass} setRole={setRole} openSignupModal={openSignupModal} setLoading={setLoading} selectedLeague={selectedLeague} setSelectedLeague={setSelectedLeague} percentOdds={percentOdds} setPercentOdds={setPercentOdds}  invalidMatches={invalidMatches} setInvalidMatches={setInvalidMatches}/>
              </>
              }>
            </Route>
            <Route path = '/admin' element={
              role === null ? null : role ? (
              <AdminDashboard user={user} setUser = {setUser} setRole={setRole} showAlert={showAlert} setShowAlert={setShowAlert} alertText={alertText} setAlertText={setAlertText} animationClass={animationClass} setAnimationClass={setAnimationClass}/>
            ) : (
              <Navigate to="/" replace />
            )
              }>
            </Route>
            <Route path = '/account' element={
              <AccountSettings user={user} setUser={setUser} walletBalance={walletBalance} setWalletBalance={setWalletBalance} isPremium={isPremium} setIsPremium={setIsPremium} openPremiumModal={openPremiumModal} closePremiumModal={closePremiumModal} openAddCoinsModal={openAddCoinsModal} closeAddCoinsModal={closeAddCoinsModal} coinsToAdd={coinsToAdd} usernameInfo={usernameInfo} setUsernameInfo={setUsernameInfo} setBetsOpen={setBetsOpen} setLoading={setLoading} handleClearAllBets={handleClearAllBets} setRole={setRole} />}>
            </Route>
            <Route path = '/leaderboard' element={
              <Leaderboard user={user} setUser={setUser} walletBalance={walletBalance} setWalletBalance={setWalletBalance} isPremium={isPremium} setIsPremium={setIsPremium} openPremiumModal={openPremiumModal} closePremiumModal={closePremiumModal} openAddCoinsModal={openAddCoinsModal} closeAddCoinsModal={closeAddCoinsModal} coinsToAdd={coinsToAdd} usernameInfo={usernameInfo} />}>
            </Route>

            <Route path='/unsubscribe' element={<Unsubscribe />} />

            <Route path = '/admin' element={
              <AdminDashboard user={user} setUser={setUser} walletBalance={walletBalance} setWalletBalance={setWalletBalance} isPremium={isPremium} setIsPremium={setIsPremium} selectedOdds={selectedOdds} setSelectedOdds={setSelectedOdds} betsOpen={betsOpen} setBetsOpen={setBetsOpen} betAmounts={betAmounts} setBetAmounts={setBetAmounts} estimatedPayouts={estimatedPayouts} setEstimatedPayouts={setEstimatedPayouts} handleClearAllBets={handleClearAllBets} openPremiumModal={openPremiumModal} closePremiumModal={closePremiumModal} showAlert={showAlert} setShowAlert={setShowAlert} alertText={alertText} setAlertText={setAlertText} animationClass={animationClass} setAnimationClass={setAnimationClass}/>}>
            </Route>

            <Route path = '/login' element={
              user === null ? 
              <LoginModal showModal={true} closeModal={closeLoginModal} user = {user} setUser = {setUser} setSignupModalOpen={setSignupModalOpen} />
              : <Navigate to="/" replace />
            }></Route>

          </Routes>
        </BrowserRouter>        
        </div>
        <div className = "mob-nav">
          <MobNavBar className={`m-auto ${betsOpen ? 'navbar':'navbarsmall'}`} openLoginModal = {openLoginModal} openSignupModal = {openSignupModal} user = {user} setUser = {setUser} selectedOdds={selectedOdds} setBetsOpen={setBetsOpen} betsOpen={betsOpen} handleClearAllBets={handleClearAllBets} walletBalance={walletBalance} loading={loading} setLoading={setLoading} setRole={setRole} setIsPremium={setIsPremium} setUsernameInfo = {setUsernameInfo} />

        </div>
        <div
          ref={betSlipShellRef}
          className={`bets-sidebar-shell ${betsOpen ? 'bets-sidebar-open' : 'bets-sidebar-closed'}`}
          aria-hidden={!betsOpen}
        >
          <BetsSidebar selectedOdds={selectedOdds} setSelectedOdds={setSelectedOdds} 
          closeSidebar={closeSidebar}  betAmounts = {betAmounts} setBetAmounts = {setBetAmounts} 
          estimatedPayouts={estimatedPayouts} setEstimatedPayouts={setEstimatedPayouts} 
          openLoginModal={openLoginModal} handleClearAllBets={handleClearAllBets} user={user} setWalletBalance={setWalletBalance} walletBalance = {walletBalance} 
          setShowAlert={setShowAlert} setAlertText={setAlertText} setAnimationClass={setAnimationClass} setUser={setUser} percentOdds={percentOdds} invalidMatches={invalidMatches} setInvalidMatches={setInvalidMatches} betsOpen={betsOpen} />
        </div>
      </div>
      
      
    </div>
  );
}

export default App;
